<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import PageGrid from '../components/pageGrid.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			body: ISbStoryData[];
			mobile_start: number;
			mobile_end: number;
			desktop_start: number;
			desktop_end: number;
			bg_color: string;
			bg_color_desktop: string;
			remove_margins: boolean;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<PageGrid mobileMargin={!content.remove_margins} desktopMargin={!content.remove_margins}>
	<div
		class="col-start-{content.mobile_start || 1} col-end-{content.mobile_end ||
			5} lg:col-start-{content.desktop_start || 1} lg:col-end-{content.desktop_end ||
			13} rounded-2xl bg-{content.bg_color || 'transparent'} lg:bg-{content.bg_color_desktop ||
			'transparent'}"
		use:editable={content}
	>
		{#each content.body || [] as block}
			<Blok content={block} />
		{/each}
	</div>
</PageGrid>
